@if ($value() !== null && $value() !== undefined) {
    <i
        #tooltip="matTooltip"
        matTooltip="Copy to clipboard"
        (mouseenter)="tooltip.message = 'Copy to clipboard'"
        (click)="copy($event, tooltip)"
        class="far fa-copy"
    ></i>
}
